"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyStates = void 0;
var react_1 = __importDefault(require("react"));
var EmptyStatesRenderer_1 = require("./comps/EmptyStatesRenderer");
var config_1 = require("./config");
var utilsOolib_1 = require("../../utilsOolib");
var EmptyStates = function (_a) {
    var _b = _a.preset, preset = _b === void 0 ? "multiplePublishingListing" : _b, contentTypeTitle = _a.contentTypeTitle, titleProp = _a.title, tags = _a.tags, onClick = _a.onClick;
    var commaSeparatedTags = tags === null || tags === void 0 ? void 0 : tags.map(function (item) { return item.toLowerCase(); }).join(",");
    var localize = (0, utilsOolib_1.useLocale)();
    var _c = (0, config_1.getEmptyStatesConfig)({
        preset: preset,
        contentTypeTitle: contentTypeTitle,
        commaSeparatedTags: commaSeparatedTags,
        title: titleProp,
        localize: localize
    }), image = _c.image, title = _c.title, subtitle = _c.subtitle, link = _c.link, button = _c.button, align = _c.align;
    return (react_1.default.createElement(EmptyStatesRenderer_1.EmptyStatesRenderer, { image: image, align: align, title: title, subtitle: subtitle, link: link, button: button, onClick: onClick, preset: preset }));
};
exports.EmptyStates = EmptyStates;
